import { render, staticRenderFns } from "./TitleDetails.vue?vue&type=template&id=d6d9e5a0&"
import script from "./TitleDetails.vue?vue&type=script&lang=js&"
export * from "./TitleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports